<template>
	<div class="index">
		<div class="content">
			<van-search v-model="serchValue" @clear="serchData" @search="serchData" placeholder="请输入搜索关键词"/>
			<van-divider style="margin: 0 var(--base-px-16)"/>
			<p class="title">
				<span class="circle-z">{{ page.total }}条</span>
				<!-- <span>历史朋友圈已发表</span> -->
				<span>历史朋友圈</span>
			</p>
			<p class="btn">
				<van-button icon="plus" type="info" @click="toCreate">发表朋友圈</van-button>
			</p>
			<div class="content-body">
				<div v-if="listData.length > 0">
					<div v-for="(i,is) in listData" class="item-list" :key="is">
						<div class="item">
							<div>
								<div style="width: var(--base-px-55);height: var(--base-px-55);flex-wrap: wrap;overflow: hidden;" v-if="i.contentType == '图片'">
									<img v-for="(it,ins) in i.image" :key="ins" :src="it.image"/>
								</div>
								<div style="width: var(--base-px-55);height: var(--base-px-55);" v-if="i.contentType == '视频'">
									<video :src="i.video"></video>
								</div>
								<span>{{ i.text.content }}</span>
							</div>
							<div>{{ i.createTime }} 由 我 发布</div>
						</div>
						<div class="wait" v-if="i.status === 0" @click="toPublish(i)">待发布</div>
						<div class="finish" v-if="i.status === 1">已发布</div>
					</div>
				</div>

				<van-empty
					v-else
					class="custom-image"
					:image="require('../../assets/images/emptyimg.png')"
					description="当前没有发表的内容"
				/>
			</div>
		</div>
		<!--  新建  -->
		<van-action-sheet
			v-model="shows"
			cancel-text="取消"
			description="你要创建哪种活码？"
			close-on-click-action
		>
			<template slot="default">
				<div @click="onSelect(item.name)" v-for="(item,index) in actions" :key="index"
				     class="checkMarkting van-hairline--bottom">
					<div class="info"><p class="fs17 title">{{ item.name }}</p>
						<span class="infotxt fs13">{{ item.subname }}</span>
					</div>
					<div class="more">
						<img src="../../assets/images/marktingAddeb.svg" class="fs16 svg-icon"
						     style="width: var(--base-px-16); height: var(--base-px-16);">
					</div>
				</div>
			</template>
		</van-action-sheet>
	</div>
</template>

<script>
import {workMoment} from "../../api/workMoment"

export default {
	data() {
		return {
			// 文字
			message: '',
			// tbas切换
			tabsChose: 0,
			serchValue: '',
			// 新建操作
			shows: false,
			actions: [
				{name: '员工活码', subname: '客户扫码添加员工时，自动给客户打标签、发欢迎语'},
				{name: '客户群活码', subname: '客户扫码加入群聊，群人数达到上限后切换新群聊'}
			],
			page: '',
			listData: ""
		}
	},
	watch: {},
	methods: {
		onClickLeft() {
			this.$router.back()
		},
		onSearch(e) {
		},
		// 新建操作
		onSelect(e) {
			this.shows = false
		},
		show() {
			this.shows = true
		},
		list() {
			workMoment({
				searchText: this.serchValue,
				page: 1,
				perPage: 1000
			}).then(res => {
				this.page = res.data.page
				this.listData = res.data.list
			})
		},
		serchData() {
			this.list()
		},
		toPublish(i) {
			this.$router.push({
				path: '/workMoment/info',
				query: {
					momentId: i.id
				}
			})
		},
		toCreate() {
			this.$router.push('./create')
		}
	},
	created() {
		this.list()
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-tabs__line {
	bottom: var(--base-px-9);
	margin-top: 0;
}

/deep/ .van-tabs__nav--line {
	padding-bottom: var(--base-px-1);
}

/deep/ .van-tab__text {
	margin-bottom: var(--base-px-10);
}

/deep/ .van-tab {
	background: #ffffff;
}

/deep/ .van-tabs__nav {
	background: #F1f2f5;
}

/deep/ .van-empty__image img {
	object-fit: contain;
}

/deep/ .van-action-sheet__description {
	font-size: var(--base-px-16);
	color: #444;
}


.checkMarkting {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: var(--base-px-10) var(--base-px-18) var(--base-px-10) var(--base-px-18);

	.fs17 {
		font-size: var(--base-px-15) !important;
	}

	.fs13 {
		font-size: var(--base-px-12) !important;
	}

	.info {
		.title {
			color: #000;
			margin-bottom: var(--base-px-5);
		}

		.infotxt {
			color: #8c8c8c;
			line-height: var(--base-px-21);
			flex-grow: 1;
		}

		.more {
			width: var(--base-px-16);
			height: var(--base-px-16);
			margin-right: var(--base-px-20);

			img {
				width: var(--base-px-16);
				height: var(--base-px-16);
			}
		}
	}
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #fff;

	p {
		margin: 0 !important;
	}

	.fs17 {
		font-size: var(--base-px-17);
	}

	.fs14 {
		font-size: .14px;
	}

	.content {
		background: #fff;
		height: 92%;
		//padding-top: var(--base-px-5);
		img {
			width: var(--base-px-22);
			height: var(--base-px-22);
		}

		.title {
			padding: var(--base-px-12) var(--base-px-16);
			justify-content: space-between;
			font-weight: 400;
			line-height: var(--base-px-18);
			font-size: var(--base-px-12);
			color: #545454;

			.circle-z {
				font-weight: 500;
				margin-right: var(--base-px-5);
				color: #000;
			}
		}

		.btn {
			width: 100%;
			padding: 0 var(--base-px-12);

			/deep/ .van-button {
				width: 100%;
			}
		}

		.content-body {
			border-top: var(--base-px-8) solid #f4f5f7;
		}

		.item-list {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: var(--base-px-16);

			.wait {
				// width: var(--base-px-60);
				padding: var(--base-px-3) var(--base-px-8);
				font-size: var(--base-px-12);
				border: var(--base-px-1) solid #f6dfb6;
				background-color: #fdf5e3;
				text-align: center;
				color: #eac67d;
				border-radius: var(--base-px-5);
			}

			.finish {
				// width: var(--base-px-60);
				padding: var(--base-px-3) var(--base-px-8);
				font-size: var(--base-px-12);
				border: var(--base-px-1) solid #dff1d7;
				background-color: #f0f8ec;
				text-align: center;
				color: #61b839;
				border-radius: var(--base-px-5);
			}

			.item {
				padding: var(--base-px-12) var(--base-px-16);
				/* border: var(--base-px-1) solid red; */
				border-bottom: var(--base-px-1) solid #f4f5f7;

				div:nth-child(1) {
					display: flex;

					img {
						flex: 1;
						/* height: var(--base-px-30); */
						display: block;
						object-fit: cover;
						height: 100%;
					}

					span {
						color: #444;
						font-size: var(--base-px-14);
						margin-left: var(--base-px-10);
					}
				}

				div:nth-child(2) {
					color: #939393;
					margin-top: var(--base-px-10);
					font-size: var(--base-px-12);
				}
			}
		}
	}
}
</style>
